import { ManuteRequestConfig } from '@/api/types';
import { AuthRequest } from './types';

const OAUTH_CONFIG = {
    client_id: process.env.VUE_APP_PASSPORT_PASSWORD_CLIENT_ID,
    client_secret: process.env.VUE_APP_PASSPORT_PASSWORD_CLIENT_SECRET,
};

/**
 * Request to login.
 * @param auth
 */
export const LOGIN = (auth: AuthRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/oauth/token',
    data: {
        grant_type: 'password',
        ...auth,
        ...OAUTH_CONFIG,
    },
    requiresAuth: false,
});

/**
 * Request to re-login to get refreshed token.
 * @param refreshToken
 */
export const REFRESH_TOKEN = (refreshToken: string): ManuteRequestConfig => ({
    method: 'POST',
    url: '/oauth/token',
    data: {
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        ...OAUTH_CONFIG,
    },
    requiresAuth: false,
});

/**
 * Request to get authenticated user info.
 */
export const USER_INFO = (): ManuteRequestConfig => ({
    method: 'GET',
    url: '/users/me',
});

/**
 * Request to check authenticated user password.
 */
export const CHECK_PASSWORD = (password: string): ManuteRequestConfig => ({
    method: 'POST',
    url: '/users/check-password',
    data: {
        password: password
    }
});
